(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arvo-cap-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arvo-cap-finder')) {
    customElements.define('arvo-cap-finder', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.tabs = Array.from(this.querySelectorAll('[data-arvo-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-arvo-panel]'));
        const tablist = this.querySelector('[data-arvo-tabs]');
        if (!this.tabs.length || this.tabs.length !== this.panels.length || !tablist) return;
        tablist.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', () => this.select(index), { signal });
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          }, { signal });
        });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex(panel => panel.contains(event.target));
          if (index >= 0) this.select(index);
        }, { signal });
        this.select(0);
        this.setAttribute('data-ready', '');
        tablist.hidden = false;
      }
      disconnectedCallback() { this.controller?.abort(); }
      select(index) {
        this.tabs.forEach((tab, position) => {
          const selected = index === position;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[position].hidden = !selected;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
